import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { UserService } from '../services/user/user.service';
import User from '../../models/User';
import TaskType from '../../models/TaskType';


export interface UserState {
  currentUser: User;
  allTaskTypeUser: TaskType[];
  inputSearchUser: string;
}

const initialState: UserState = {
  currentUser: {},
  allTaskTypeUser: [],
  inputSearchUser: ''
}

const authService = new AuthenticationService();
const userService = new UserService();
export const userSlice = createSlice({
  name: 'user',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setInputSearchUser: (state, action: PayloadAction<string>) => {
      state.inputSearchUser = action.payload;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder.addCase(postLogin.fulfilled, (state, action) => {
      state.currentUser = action.payload.data;
    });
    builder.addCase(
      getUserProfile.fulfilled,
      (state, action: PayloadAction<any>) => {
        // Tipos de tareas creadas por dicho Usuario se obtiene del perfil del usuario
        if (action.payload.data !== undefined) {
          state.currentUser = action.payload.data;
          state.allTaskTypeUser = action.payload.data.rol ? action.payload.data.rol.tipostareas : [];
        } else {
          state.allTaskTypeUser = [];
        }
      },
    );
  },
});

export const postLogin = createAsyncThunk(
  'login',
  async (loginParameters: { username: string; password: string }) => {
    return authService.userLogIn(
      loginParameters.username,
      loginParameters.password,
    );
  },
);
export const postLogOut = createAsyncThunk('logOut', async () => {
  return authService.logOut();
});
export const createUser = createAsyncThunk(
  'create_user',
  async (user: User) => {
    return userService.postUser(user);
  },
);
export const getUsers = createAsyncThunk('get_users', async () => {
  return userService.getUsers();
});
export const updateUser = createAsyncThunk(
  'update_user',
  async (user: User) => {
    return userService.updateUser(user);
  },
);
export const deleteUser = createAsyncThunk(
  'delete_user',
  async (user: User) => {
    return userService.deleteUser(user);
  },
);
export const userPasswordCreate = createAsyncThunk(
  'create_password',
  async (passwordParameters: { token: string; password: string }) => {
    return authService.userPasswordCreate(
      passwordParameters.token,
      passwordParameters.password,
    );
  },
);
export const forgotPassword = createAsyncThunk(
  'forgot_password',
  async (email: string) => {
    return authService.forgotPassword(email);
  },
);
export const inviteUser = createAsyncThunk(
  'invite_user',
  async (userId: string) => {
    return authService.inviteUser(userId);
  },
);
export const resetPassword = createAsyncThunk(
  'reset_password',
  async (passwordParameters: { token: string; password: string }) => {
    return authService.resetPassword(
      passwordParameters.token,
      passwordParameters.password,
    );
  },
);
export const getUserProfile = createAsyncThunk('user_profile', async () => {
  return authService.getUserProfile();
});

export const {
  setInputSearchUser
} = userSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.user.value)`
export const selectUser = (state: RootState) => state.user.currentUser;
export const selectListTaskType = (state: RootState) => state.user.allTaskTypeUser;
export const selectInputSearchUser = (state: RootState) => state.user.inputSearchUser;

export default userSlice.reducer;